import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { v4 as uuid } from "uuid";
import { useForm } from "react-hook-form";
import { useState } from "react";

import FormInputError from "components/General/FormInputError";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import moment from "moment/moment";
import config from "config/config";
const UnauthCustomerAuthorizePaymentModal = ({
  modalState,
  setModalState,
  unauthUser,
  submitParentData,
  submitFuction,
  setConfirmationModal,
  uid,
  isNonNaturalEntity,
}) => {
  const UUID = uuid();
  const { register: authorizeModalRegister, getValues } = useForm();

  const [error, setError] = useState();
  const [disableSubmit, setDisableSubmit] = useState(!isNonNaturalEntity);
  let debounceFunction; //timer identifier
  let debounceTimer = 1500; //time in ms, 1.5 seconds for example

  return (
    <Transition appear show={modalState} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        open={modalState}
        onClose={() => {
          setModalState(false);
        }}
      >
        <DialogBackdrop />

        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-5xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h2"
                className="dialog_label2 font-body text-xl font-bold text-left"
              >
                Authorize payment
                <button
                  className="ui-default-dialog-close"
                  onClick={() => setModalState(false)}
                >
                  <svg
                    className="ui-icon h-3.5 w-3.5"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-close"></use>
                  </svg>
                </button>
              </Dialog.Title>
              <hr />
              <form
                method="GET"
                action={`${config.HOSTED_PAYMENT_SERVICE_BASE_URL}`}
              >
                <div className="mx-auto lg:w-4/5">
                  {config.ENABLE_ADD_CREDIT_CARD_UPDATE === "true" ? (
                    <>
                      <p id="ID_dialogAuthorizePaymentDesc">
                        By checking the box below, I acknowledge I will be
                        redirected to a third-party payment provider where I
                        will securely enter my credit card details for this
                        payment. I authorize this payment to be processed and
                        remitted to <strong>Everlake</strong>. I understand that
                        by entering my credit card information and clicking the
                        “Pay” button on that page I am submitting the payment
                        request and providing my electronic signature.
                      </p>

                      <div className="mt-6">
                        <label className="ui-checkbox">
                          <input type="checkbox" required />
                          <div className="ui-checkmark">
                            <svg
                              className="ui-icon w-2 h-2 text-white"
                              focusable="false"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <use href="#ui-icon-checkmark"></use>
                            </svg>
                          </div>
                          <span>
                            I authorize this payment request on{" "}
                            {moment().format("MM/DD/YYYY")}.
                          </span>
                        </label>
                      </div>
                    </>
                  ) : (
                    <>
                      <p id="ID_dialogAuthorizePaymentDesc">
                        By checking the box below I authorize this payment to be
                        processed and remitted to <strong>Everlake</strong>{" "}
                        through my <strong>credit card</strong> as referenced
                        herein. I understand that by clicking the “Submit”
                        button below that I am submitting the payment request
                        and providing my electronic signature.
                      </p>

                      <div className="mt-6">
                        <label className="ui-checkbox">
                          <input type="checkbox" required />
                          <div className="ui-checkmark">
                            <svg
                              className="ui-icon w-2 h-2 text-white"
                              focusable="false"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <use href="#ui-icon-checkmark"></use>
                            </svg>
                          </div>
                          <span>
                            I authorize this payment request on{" "}
                            {moment().format("MM/DD/YYYY")}.
                          </span>
                        </label>
                      </div>
                    </>
                  )}

                  {unauthUser && (
                    <>
                      <div className="ui-form-card-no-event mt-4">
                        <label
                          id={UUID + "-name-label"}
                          htmlFor={`${UUID}-name`}
                          className="block mb-1"
                        >
                          Enter first and last name *
                        </label>
                        <input
                          id={`first-name`}
                          aria-labelledby={UUID + "-name-label"}
                          aria-describedby={`${UUID + "-name-help"} ${
                            UUID + "-name-error"
                          }`}
                          type="text"
                          required={!isNonNaturalEntity}
                          placeholder="Enter first and last name"
                          {...authorizeModalRegister("name")}
                          onKeyUp={() => {
                            if (isNonNaturalEntity) {
                              setDisableSubmit(false);
                              return;
                            }
                            clearTimeout(debounceFunction);
                            debounceFunction = setTimeout(async () => {
                              if (
                                getValues("name") !== getValues("confirmName")
                              ) {
                                setError(
                                  "Confirm first and last name do not match"
                                );
                                setDisableSubmit(true);
                              } else {
                                setError(undefined);
                                setDisableSubmit(false);
                              }
                            }, debounceTimer);
                          }}
                          onKeyDown={() => {
                            clearTimeout(debounceFunction);
                          }}
                        />
                      </div>

                      <div className="ui-form-card-no-event mt-4">
                        <label
                          id={UUID + "-confirm-label"}
                          htmlFor={`${UUID}-confirm`}
                          className="block mb-1"
                        >
                          Type first and last name to confirm *
                        </label>
                        <input
                          id={`${UUID}-confirm`}
                          aria-labelledby={UUID + "-confirm-label"}
                          aria-describedby={`${UUID + "-confirm-help"} ${
                            UUID + "-confirm-error"
                          }`}
                          type="text"
                          required={!isNonNaturalEntity}
                          placeholder="Enter name again to confirm"
                          {...authorizeModalRegister("confirmName")}
                          onKeyUp={() => {
                            clearTimeout(debounceFunction);
                            debounceFunction = setTimeout(async () => {
                              if (
                                getValues("name") !== getValues("confirmName")
                              ) {
                                setError(
                                  "Confirm first and last name do not match"
                                );
                                setDisableSubmit(true);
                              } else {
                                setError(undefined);
                                setDisableSubmit(false);
                              }
                            }, debounceTimer);
                          }}
                          onKeyDown={() => {
                            clearTimeout(debounceFunction);
                          }}
                        />
                        {error && <FormInputError errorMessage={error} />}
                      </div>
                    </>
                  )}
                  <div className="block text-right mt-6">
                    <input type="hidden" name="uid" value={`${uid}`} />
                    <button
                      type="button"
                      className="ui-btn-secondary min-w-[140px] mt-4"
                      aria-label="Cancel authorizing this payment"
                      onClick={() => setModalState(false)}
                    >
                      Cancel
                    </button>
                    <button
                      id="ID_submitAuthorizePayment"
                      className="ui-btn-primary min-w-[140px] mt-4"
                      aria-label="unauthorize this payment"
                      disabled={disableSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default UnauthCustomerAuthorizePaymentModal;
